import { SelectionChangedEvent } from "ag-grid-community";
import { ProposalCopyingForRecalItemEntity } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalItemEntity";
import { proposalByDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { standardProposalRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { INITIAL_STANDARD_PROPOSAL_DETAIL_COL_DEF, transferRowData } from "presentation/constant/StandardProposal/StandardProposalDetailColumnDefinition";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { OverflowMenuButton } from "presentation/view/components/OverflowMenuButton";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef } from "react";
import { FieldType, IconButton, IFieldValue, Loader, OverflowingSubMenu } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const ProposalCopyingForRecalTariffItemTablePanel: React.FC = () => {
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const gridRef: any = useRef(null);
    // const [isLoading, setIsLoading] = useState<boolean>(false);
    // const [isShowDelete, setIsShowDelete] = useState<boolean>(false);
    // const [deletedRows, setDeletedRows] = useState<ProposalCopyingForRecalItemEntity[]>();
    const { isShowCopyToCompanyPanel, isShowEditPanel, currentSelectedRow, tariffItemList, selectedItemRows, isForRecal, isShowTariffItemTierPanel } = proposalCopyingForRecalState;
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        proposalCopyingForRecalVM.updateSelectedTariffItemRows(selectedRows);
    }, [proposalCopyingForRecalVM])

    const handClose = useCallback(() => {
        proposalCopyingForRecalVM.onTariffItemCloseClick();
    }, [proposalCopyingForRecalVM]);


    const isRowSelectable = useCallback(() => {
        return !(isShowCopyToCompanyPanel || isShowEditPanel || isShowTariffItemTierPanel)
    }, [isShowCopyToCompanyPanel, isShowEditPanel, isShowTariffItemTierPanel]);


    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.companyCode || ''}
                fieldValue={currentSelectedRow?.companyCode}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE, currentSelectedRow?.companyCode, proposalCopyingForRecalVM])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.operatingTml || ''}
                fieldValue={currentSelectedRow?.operatingTml}
                fieldLabel={SCREEN_CONSTANT.OPERATING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.OPERATING_TML, currentSelectedRow?.operatingTml, proposalCopyingForRecalVM])

    const memoEffectiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE}
                width="185px"
                date={currentSelectedRow?.effectiveDate}
                fieldName="effectiveDate"
                errorMessage={""}
                onDateChange={proposalCopyingForRecalVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE, currentSelectedRow?.effectiveDate, proposalCopyingForRecalVM.onFieldChange])

    const memoExpiryDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <DatePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.EXPIRY_DATE}
                width="185px"
                date={currentSelectedRow?.expiryDate}
                fieldName="expiryDate"
                errorMessage={""}
                onDateChange={proposalCopyingForRecalVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.EXPIRY_DATE, currentSelectedRow?.expiryDate, proposalCopyingForRecalVM.onFieldChange])

    const memoCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.currencyCode || ''}
                fieldValue={currentSelectedRow?.currencyCode}
                fieldLabel={SCREEN_CONSTANT.CURRENCY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'currencyCode'}
                maxLength={60}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CURRENCY, currentSelectedRow?.currencyCode, proposalCopyingForRecalVM])

    const memoProposalBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.proposalBy || ''}
                fieldValue={currentSelectedRow?.proposalBy}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_BY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalCreatedByMethod'}
                maxLength={60}
                options={proposalByDropdownOption}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_BY, currentSelectedRow?.proposalBy, proposalCopyingForRecalVM])
    /*
        const memoStatus = useMemo(() =>
            <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={true}
                    isShowOptional={true}
                    readOnlyValue={currentSelectedRow?.status || ''}
                    fieldValue={currentSelectedRow?.status}
                    fieldLabel={SCREEN_CONSTANT.STATUS}
                    isSaveClicked={false}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'status'}
                    maxLength={60}
                    options={approvalProcessStatusDropdownOption}
                    requiredFieldList={standardProposalRequiredFieldList}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
            </div>
            , [SCREEN_CONSTANT.STATUS, currentSelectedRow?.status, proposalCopyingForRecalVM])
    */
    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.proposalNo || ''}
                fieldValue={currentSelectedRow?.proposalNo}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={60}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_NO, currentSelectedRow?.proposalNo, proposalCopyingForRecalVM])

    const memoNature = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentSelectedRow?.tariffNature && currentSelectedRow?.tariffNature?.length <= 20 ? currentSelectedRow?.tariffNature : (currentSelectedRow?.tariffNature?.substring(0, 20) + '...') || ''}
                fieldValue={currentSelectedRow?.tariffNatureList}
                allValues={currentSelectedRow?.tariffNature ?? ""}
                fieldLabel={SCREEN_CONSTANT.TARIFF_NATURE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffNatureList'}
                maxLength={600}
                isMultipleDropDown={true}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TARIFF_NATURE, currentSelectedRow?.tariffNature, currentSelectedRow?.tariffNatureList, proposalCopyingForRecalVM])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' id="std-proposal-edit-remarks" style={{ width: "405px", marginBottom: "24px", marginLeft: "15px" }} >
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentSelectedRow?.remarks || ''}
                fieldValue={currentSelectedRow?.remarks}
                fieldLabel={SCREEN_CONSTANT.REMARKS}
                isSaveClicked={false}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'remarks'}
                maxLength={100}
                rows={1}
                requiredFieldList={standardProposalRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)}
            />
        </div>
        , [SCREEN_CONSTANT.REMARKS, currentSelectedRow?.remarks, proposalCopyingForRecalVM])


    const isDisableCopyToNewProposal = useCallback(() => {
        return selectedItemRows.length === 0
    }, [selectedItemRows.length]);

    const handleCopyToNewProposalClick = useCallback(async () => {
        proposalCopyingForRecalVM.onCopyToCompanyOpenClick(true);
    }, [proposalCopyingForRecalVM]);

    const handleCopyToCombineProposalClick = useCallback(async () => {
        proposalCopyingForRecalVM.onCopyToCompanyOpenClick(false);
    }, [proposalCopyingForRecalVM]);

    const handleRecalItemDoubleClick = useCallback(async (entity: ProposalCopyingForRecalItemEntity) => {
        proposalCopyingForRecalVM.onRecalItemDoubleClick(entity, isForRecal);
    }, [isForRecal, proposalCopyingForRecalVM]);

    // const handDelete = useCallback(() => {
    //     if (selectedItemRows.length < 1) {
    //         messageBarVM.showError("Please select a record.");
    //         return;
    //     }
    //     setIsShowDelete(true);
    //     setDeletedRows(selectedItemRows);
    // }, [messageBarVM, selectedItemRows]);

    // const handleCancel = () => {
    //     setIsShowDelete(false);
    //     setDeletedRows([]);
    // }

    // const handleDelete = () => {
    //     setIsLoading(true);
    //     setIsShowDelete(false);
    //     if (!deletedRows) return;

    //     proposalCopyingForRecalVM.onDeleteItemsClick(deletedRows).then(async (data) => {
    //         if ((data && data.success)) {
    //             messageBarVM.showSuccess("Delete Successfully");
    //             await proposalCopyingForRecalVM.searchStandardProposalItem(currentSelectedRow);
    //             setIsLoading(false);
    //         } else {
    //             messageBarVM.showError(data.data ?? "Delete Failed");
    //             setIsLoading(false);
    //             return;
    //         }
    //     }).catch((error) => {
    //         setIsLoading(false);
    //     }).finally(() => {
    //         setIsLoading(false);
    //     });
    // }

    // const memoBtns = useMemo(() => {

    //     const hdrBtns = [];
    //     if (isForRecal && !isShowEditTierPanel && isShowCopyToCompanyPanel) {
    //         hdrBtns.push({
    //             id: 'onDeleteButton',
    //             icon: 'Icon-trash',
    //             title: 'Delete',
    //         })
    //     }

    //     return hdrBtns
    // }, [isForRecal, isShowEditTierPanel, isShowCopyToCompanyPanel])

    const memoTableTitle = useMemo(() => {

        const copyItemList: OverflowingSubMenu[] = [{
            title: 'New',
            command: handleCopyToNewProposalClick
        },
        {
            title: 'Combine',
            command: handleCopyToCombineProposalClick
        }
        ];

        return (
            allowUpdate && <>
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <OverflowMenuButton disabled={isDisableCopyToNewProposal()} icon="Icon-copy" toolTipText="Copy" navigationList={copyItemList} className={"title-overflowMenu-forStdProposalCopy"} />
                </div>
            </>
        )
    }, [handleCopyToCombineProposalClick, handleCopyToNewProposalClick, isDisableCopyToNewProposal, allowUpdate])


    const memoTariffItemTable = useMemo(() => {

        return (
            <NbisTable
                id='standard-proposal-detail-table'
                isNewColumnSetting={true}
                columns={INITIAL_STANDARD_PROPOSAL_DETAIL_COL_DEF?.slice()}
                data={transferRowData(tariffItemList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                // headerActionButtons={memoBtns}
                // onDeleteButton={handDelete}
                showUploadIcon={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                onRowDoubleClick={(e: any, entity: ProposalCopyingForRecalItemEntity) => handleRecalItemDoubleClick(entity)}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight={"calc(100vh - 345px)"}
                ref={gridRef}
                messageVM={messageBarVM}
                handleRowSelectable={isRowSelectable}
                headerLabel={!isShowCopyToCompanyPanel ? memoTableTitle : ''}
            />
        );
    }, [tariffItemList, handleSelectionChange, messageBarVM, isRowSelectable, isShowCopyToCompanyPanel, memoTableTitle, handleRecalItemDoubleClick])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowCopyToCompanyPanel, isShowEditPanel, isShowTariffItemTierPanel])

    return <><div className="main-comp-wrapper">
        <div className="main-comp-wrapper">
            {/* <TableWrapper> */}
            <div style={{ height: ('25%') }}>
                <div className={'flex-row'}>
                    <div className={'flex-row-item flex-row-item-full-width'}>
                        <Sidebarheader>
                            <SidebarTitle></SidebarTitle>
                            <SidebarActionCross>
                                {<IconButton
                                    fileName="Icon-cross" size="medium" toolTipText='Close' disabled={isShowCopyToCompanyPanel || isShowEditPanel} toolTipArrow={false} onClick={handClose} />}
                            </SidebarActionCross>
                        </Sidebarheader>
                    </div>
                </div>
                <Sidebarheader style={{ width: '100%' }}>
                    <CriteriaItemContainer>
                        {memoCompanyCode}
                        {memoProposalNo}
                        {/* {memoStatus} */}
                        {memoProposalBy}
                        {memoEffectiveDate}
                        {memoExpiryDate}
                        {memoOperatingTml}
                        {memoCurrency}
                        {memoNature}
                        {/* {memoRejectReason} */}
                        {memoRemarks}
                    </CriteriaItemContainer>
                </Sidebarheader>
            </div>
            <div style={{ height: ('75%') }}>
                {(proposalCopyingForRecalState.isLoading) && <Loader Indicator="Spinner" size="Medium" />}
                <TableWrapper>
                    {memoTariffItemTable}
                </TableWrapper>
                {/* <ConfirmDeleteModal headerText={`${WorkspaceConstant.Common.BUTTON_DELETE} ${ProposalCopyingForRecalConstant.Title.TITLE}`}
                    contentText={`${MessageConstant.common.DELETE_ALERT_TITLE}\n${MessageConstant.common.DELETE_ALERT_MESSAGE}`}
                    visible={isShowDelete}
                    onCancelClick={handleCancel}
                    onDeleteClick={handleDelete}
                /> */}
            </div>
        </div>
    </div></>;
}

export default memo(ProposalCopyingForRecalTariffItemTablePanel);
